import React from 'react';
import { Row } from 'antd';
import { IConfig } from '.';
import ABSButton from '../ABSButton';
import commonUtils from '../../utils/commonUtils';

// 保存所有的relatedKey
const relatedKeyData = new Set();
// 保存关联key和选中的subkey
const keyAndRelatedData = new Map();
// 获取选中的关联值，用于刷新获取的【全部】数据
let relatedSelectedKey;

/**
 * 设置刷新数据
 * @param param0
 * @returns
 */
export function setData({ formRef, defaultConfig, data, that, onClick, onCancel }: any) {
  const newConfig = defaultConfig.concat([]);

  if (!data || commonUtils.isEmpty(data)) {
    return;
  }

  for (const { title, value, relatedkey: rk, key } of data) {
    let defaultValue = 0;

    const { length = 0 } = value;

    if (!relatedKeyData.has(rk)) {
      relatedKeyData.add(rk);
    }

    const selectOptions: any = value.map((items: any, index: number) => {
      const labelName = commonUtils.getValue(items, 'value', '') || '';
      const selectKey = commonUtils.getValue(items, 'key', '') || '';
      const rks: any[] = commonUtils.getValue(items, 'relatedkey', []) || [];

      // 重置为【全部】，只能执行一次
      if (keyAndRelatedData.has(rk) && relatedSelectedKey === rk && length === index + 1 && formRef) {
        formRef.elementsObj[key].reset();
      }

      // 这里处理返回的option数据
      // 选择的是【全部】、选项中对应的数据
      const relatedSubKeys = keyAndRelatedData.get(rk) || 0;
      if (`${relatedSubKeys}` === '0' || rks.indexOf(relatedSubKeys) !== -1) {
        if (items.selected) {
          defaultValue = selectKey;
        }
        return { labelName, value: selectKey };
      }
      return {};
    });

    const options: any[] = `${value[0].key}` === '0' ? selectOptions : [{ labelName: '全部', value: 0 }].concat(selectOptions);

    const selectItem: IConfig = {
      key: rk,
      type: 'select',
      title,
      placeholder: `请选择${title}`,
      name: key,
      defaultValue,
      onChange: (select: string, option: any[], srk: any) => {
        // 判断key是否有关联的key，没有则不刷新数据
        if (!relatedKeyData.has(srk)) {
          return;
        }
        relatedSelectedKey = srk;
        // 获取所有选中的数据【关联的key，关联的key选中的子key】
        keyAndRelatedData.set(srk, select);
        setData({ formRef, defaultConfig, data, that, onClick, onCancel });
      },
      select: {
        options,
        relatedKey: key
      }
    };

    newConfig.push(selectItem);
  }

  newConfig.push({
    type: 'custom',
    title: '',
    name: '',
    isWrap: false,
    custom: {
      render: () => (
        <Row style={{ marginLeft: 6 }}>
          <ABSButton style={{ marginRight: 10 }} onClick={onClick}>
            确定
          </ABSButton>
          <ABSButton type="default" onClick={onCancel}>
            取消
          </ABSButton>
        </Row>
      )
    }
  });

  that.setState({ config: newConfig.slice() });
}

/**
 * 提交数据，请求结果
 * @param param0
 * @returns
 */
export function submit({ onSubmit, formRef }: any) {
  if (!onSubmit) {
    return;
  }
  if (formRef) {
    const values = formRef.getValue();
    const filterList: any[] = [];
    const result: any = {};
    for (const keys of Object.keys(values)) {
      if (!Number.isNaN(Number(keys))) {
        filterList.push({ key: keys, value: [values[keys]] });
        continue;
      }
      if (keys === 'event') {
        const { start, end } = values[keys];
        result[`EventBegin`] = start;
        result[`EventEnd`] = end;
        continue;
      }
      result[`${keys}`] = values[keys];
    }
    result.filter_query_list = filterList;
    onSubmit(result);
    return;
  }
  onSubmit({});
}

/**
 * 清空数据
 * @param param0
 */
export function cancel(params: any) {
  relatedKeyData.clear();
  keyAndRelatedData.clear();
  relatedSelectedKey = null;
  const { formRef } = params;
  if (formRef) {
    formRef.reset();
  }
  setData(params);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSFlexibleFilter/utils.tsx